import React, {useEffect} from 'react';
import './styles.scss';
import {connect} from 'react-redux';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../store/actions';
import {compose} from 'redux';
import RegisterHeader from '../../../components/headers/register-header';
import {Column, Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import {strings} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import colors, {pageBackgrounds} from '../../../util/colors';
import {useHistory} from 'react-router-dom';
import {createGUID, labelsParagraphs} from '../../../util/utility';
import AppParagraph from '../../../components/app-paragraph';
import {post} from '../../../api/api';
import AppButton from './../../../components/app-button/index';
import {uriSendConsents} from '../../../api/endpoints';
import {AuthConsumer} from '../../../providers/AuthProvider';
import FooterWave from '../../../components/footer/footer-wave';

// const labels = strings.pt.login;

export interface DataTreatmentProps {
  wizard: any;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  digitalCommunications: any;
  labels: typeof strings.pt.login;
  oneTrustLabels: typeof strings.pt.oneTrust;
  stringsDefault: any;
  user: any;
}

const DataTreatment = (props: any) => {
  const {digitalCommunications, labels} = props;
  const history = useHistory();

  // converts any '\r\n' in the labels to "<p></p>"
  labelsParagraphs(labels);
  labelsParagraphs(props.stringsDefault);

  const onSubmit = async () => {
    try {
      const result = post(
        uriSendConsents(),
        JSON.stringify(props.wizard.consentList)
      );
    } catch (e) {
    } finally {
      if (digitalCommunications === null) {
        history.push('/informacao-seguro');
      } else {
        history.push('/inicio');
      }
    }
  };

  useEffect(() => {
    props.addToGlobalStyles({
      background: pageBackgrounds.registerPage,
    });
  }, []);

  return (
    <AuthConsumer>
      {({logout}) => (
        <>
          <Column className="register-main-column">
            <RegisterHeader />
            <Column className="register-container">
              <Row className="register-header-row">
                <Header1
                  style={{...fonts.XL, color: colors.black}}
                  className="data-treatment-title">
                  {labels?.dataTreatment_title}
                </Header1>
                <Header1
                  style={{...fonts.L, color: colors.black}}
                  className="data-treatment-title-responsive">
                  {labels?.dataTreatment_title}
                </Header1>
              </Row>
              <div className="data-treatment-body-container">
                <Column>
                  <Row
                    className="data-treatment-description"
                    style={{...fonts.M}}>
                    <Column>
                      <AppParagraph
                        className="paragraph"
                        label={props.stringsDefault.dataTreatment_description}
                      />
                      <p></p>
                      <Row>
                        <p>
                          {
                            props.stringsDefault
                              .dataTreatment_descriptionLastLine
                          }
                          <a
                            href={
                              'http://' + labels?.dataTreatment_moreInfoLink
                            }
                            className="moreInfo-link"
                            style={{color: colors.blue}}>
                            {labels?.dataTreatment_moreInfo}
                          </a>
                          .
                        </p>
                      </Row>
                    </Column>
                  </Row>
                  <Row className="data-treatment-description-responsive">
                    <Column>
                      <AppParagraph
                        label={props.stringsDefault.dataTreatment_description}
                      />
                      <p></p>
                      <Row>
                        <Column>
                          {
                            props.stringsDefault
                              .dataTreatment_descriptionLastLine
                          }
                          <a
                            href={labels?.dataTreatment_moreInfoLink}
                            className="moreInfo-link-responsive"
                            style={{color: colors.blue}}>
                            {labels?.dataTreatment_moreInfo}
                          </a>
                        </Column>
                      </Row>
                    </Column>
                  </Row>
                </Column>
              </div>
              <Row className="continue-button-wrapper">
                <AppButton
                  className="continue-button-dt"
                  variant="primary"
                  onClick={() => onSubmit()}>
                  {labels?.dataTreatment_continue}
                </AppButton>
              </Row>
              <Row className="refuse-link-row">
                <a
                  onClick={() => logout()}
                  className="refuse-link"
                  style={{color: colors.blue}}>
                  {labels?.dataTreatment_exit}
                </a>
              </Row>
            </Column>
          </Column>
          <FooterWave color={colors.blue} />
        </>
      )}
    </AuthConsumer>
  );
};

const mapStateToProps = ({
  wizard,
  digitalCommunications,
  strings,
  stringsDefault,
  user,
}: any) => ({
  wizard: wizard.value,
  digitalCommunications: digitalCommunications.value,
  stringsDefault: stringsDefault.value.pt.login,
  labels: strings.value.pt.login,
  oneTrustLabels: strings.value.pt.oneTrust,
  user: user.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DataTreatment)
);
